module.exports = __webpack_public_path__ + "media/images/athletes/2689-0fc05ebc537c6d46bc29d382274c501f.png";